<template>
  <section>
    <h2>Страница не найдена!</h2>
    <p>
      Запрашиваемая страница не найдена. Может быть переместиться на
      <router-link to="/clock">главную?</router-link>
    </p>
  </section>
</template>
